import {
  SET_MARKETING_ASSETS,
  SET_MARKETING_ASSETS_LOADER,
  SET_MARKETING_ASSETS_ERROR
} from 'constants/types';

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  error: null
};

function marketingAssetsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_MARKETING_ASSETS:
      return { ...state, data: action.payload };
    case SET_MARKETING_ASSETS_LOADER:
      return { ...state, isLoading: action.payload };
    case SET_MARKETING_ASSETS_ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
  }
}

export default marketingAssetsReducer;
